<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="right menu"></div>
      <a href="#" class="red item" @click.prevent="addReason"><i class="plus icon"></i> Add Reason</a>
    </div>
    <div class="ui container">
      <h3 class="ui header">
        Reasons
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <table class="ui table">
        <thead>
        <tr>
          <th>
            Reason
          </th>
          <th class="collapsing">
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="reason in reasons">
          <td>{{ reason.title }}</td>
          <td class="collapsing">
            <div class="ui tiny buttons">
              <div class="ui button" @click="editReason(reason)"><i class="edit icon"></i> Edit Reason</div>
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="editReason(reason)"><i class="edit icon"></i> Edit Reason</div>
                  <div class="item" @click="triggerDeleteReason(reason)"><i class="trash icon"></i> Delete Reason</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>


    </div>

    <div class="ui small basic delete modal">
      <div class="header" style="text-align: center">
        Are you sure?
      </div>
      <div class="content" style="text-align: center">
        Delete reason <strong v-if="reasonForDelete">{{ reasonForDelete.name }}</strong>
      </div>
      <div class="actions" style="text-align: center">
        <div class="ui red basic cancel inverted button">
          <i class="remove icon"></i>
          No
        </div>
        <div class="ui green ok inverted button" @click="deleteReason(reasonForDelete)">
          <i class="checkmark icon"></i>
          Yes
        </div>
      </div>
    </div>

    <div class="ui small modal" id="reasonModal">
      <i class="close icon"></i>
      <div class="header">
        <span v-if="reason._id">Edit Reason</span>
        <span v-else>Add Reason</span>
      </div>
      <div class="content">
        <form class="ui form" @submit.prevent>
          <div class="ui field">
            <label>Reason</label>
            <input class="ui input" v-model="reason.title">
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui icon cancel button">
          <i class="delete icon"></i> Close
        </div>
        <div class="ui icon positive button" @click="saveReason">
          <i class="checkmark icon"></i> Save Reason
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
        'reasons': [],
        'settings': {},
        'reason': {},
        'reasonForDelete': null,
        'fetching': false,
        'moment': moment
      }
    },
    mounted() {
      this.fetchReasons()

      services.reasonService.on('created', () => {
        this.fetchReasons()
      })
      services.reasonService.on('patched', () => {
        this.fetchReasons()
      })
      services.reasonService.on('removed', () => {
        this.fetchReasons()
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    beforeDestroy() {
      $('.ui.modals').remove()
    },
    methods: {
      fetchReasons() {
        this.fetching = true

        services.reasonService.find().then(reasons => {
          this.reasons = reasons.data
          this.fetching = false
          this.initDropdown()
        })
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        console.log('open reservation')
        this.editReservation = reservation
        $('#reservationModal').modal({}).modal('show')
      },
      showReasonModal() {
        $('#reasonModal').modal('show')
      },
      editReason(reason) {
        this.reason = reason
        this.showReasonModal()
      },
      addReason() {
        this.reason = {
          title: null,
        }
        this.showReasonModal()
      },
      saveReason() {
        if (this.reason._id) {
          services.reasonService.patch(this.reason._id, this.reason).then(reason => {
            toastr.success('Reason saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        } else {
          services.reasonService.create(this.reason).then(reason => {
            toastr.success('Reason saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        }
      },
      triggerDeleteReason(reason) {
        this.reasonForDelete = reason

        $('.ui.delete.modal').modal('show')
      },
      deleteReason(reason) {
        services.reasonService.remove(reason._id).then(reason => {
          toastr.info(`Removed reason <strong>${reason.title}</strong>`, 'Reason removed!')
        })
      }
    },
    components: {}
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }

  .red.item {
    color: #771d14;
  }

  .calendar.item {
    padding: 4px 1px 0;
  }

  .text.input input {
    border: none;
  }

  .text.input.item {
    padding: 10px;
  }

  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Reasons.vue?f3068406